import { render, staticRenderFns } from "./stockgroups.vue?vue&type=template&id=52913a0e&scoped=true&"
import script from "./stockgroups.vue?vue&type=script&lang=js&"
export * from "./stockgroups.vue?vue&type=script&lang=js&"
import style0 from "./stockgroups.vue?vue&type=style&index=0&id=52913a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52913a0e",
  null
  
)

export default component.exports